import { z } from "zod";
import { TaxConfigSchema } from "../schemas/TaxSchema";

// Full replacement input: no implicit defaults at the write boundary.
export const TaxSettingsDataSchema = TaxConfigSchema.extend({
  countryCode: z
    .string()
    .trim()
    .regex(/^[A-Z]{2}$/),
  standardTaxRate: z.number().finite().min(0).max(100),
  taxationMethod: TaxConfigSchema.shape.taxationMethod.removeDefault(),
  taxPeriod: TaxConfigSchema.shape.taxPeriod.removeDefault(),
  hasPermanentExtension: z.boolean(),
  isSmallBusiness: z.boolean(),
  isOssRegistered: z.boolean(),
  isIossRegistered: z.boolean(),
  smallBusinessNote: z.string().trim().max(10000),
  reverseChargeNote: z.string().trim().max(10000),
  intraCommunitySupplyNote: z.string().trim().max(10000),
  exportDeliveryNote: z.string().trim().max(10000),
  defaultPaymentTermsDays:
    TaxConfigSchema.shape.defaultPaymentTermsDays.removeDefault(),
  cashDiscountDays: TaxConfigSchema.shape.cashDiscountDays.removeDefault(),
  cashDiscountPercentage:
    TaxConfigSchema.shape.cashDiscountPercentage.removeDefault(),
  retentionPeriodYears: z.number().int().min(10).max(30),
  accountingSystem: TaxConfigSchema.shape.accountingSystem.removeDefault(),
}).strict();
// Partial stored facts: optional wrapper prevents schema defaults on reads.
// Numeric/country ranges are checked on saving so legacy values can be repaired.
export const TaxSettingsStoredSchema = TaxSettingsDataSchema.extend({
  countryCode: z.string(),
  standardTaxRate: z.number().finite(),
  retentionPeriodYears: z.number().finite(),
}).partial();
export const TaxSettingsRecordSchema = z.object({
  id: z.string().uuid(),
  updatedAt: z.string().min(1).max(128),
  taxConfig: TaxSettingsStoredSchema.nullable(),
});
export const TaxSettingsSaveSchema = z
  .object({
    data: TaxSettingsDataSchema,
    expectedUpdatedAt: z.string().min(1).max(128),
  })
  .strict();
export type TaxSettingsData = z.infer<typeof TaxSettingsDataSchema>;
export type TaxSettingsRecord = z.infer<typeof TaxSettingsRecordSchema>;
export type TaxSettingsSave = z.infer<typeof TaxSettingsSaveSchema>;
